/**
 * 统一筛选栏组件 - 改进对齐
 */
import React, { memo } from 'react';
import { Card, Input, Select, DatePicker, Button, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Search } = Input;
const { Text } = Typography;

/**
 * 统一筛选栏组件
 * @param {Object} props
 * @param {Function} props.onSearch - 搜索回调
 * @param {Function} props.onReset - 重置回调
 * @param {string} props.searchPlaceholder - 搜索框占位符
 * @param {boolean} props.showSearch - 是否显示搜索框
 * @param {Array} props.filters - 筛选器配置
 * @param {React.ReactNode} props.actions - 操作按钮
 * @param {string} props.className - 自定义类名
 */
const FilterBar = ({
  onSearch,
  onReset,
  searchPlaceholder = '搜索关键字...',
  showSearch = true,
  filters = [],
  actions,
  className = '',
  loading = false
}) => {
  return (
    <Card className={`filter-card ${className}`}>
      <div className="filter-bar-content">
        <div className="filter-bar-row">
          {showSearch && (
            <div className="filter-bar-item filter-bar-search">
              <Search
                placeholder={searchPlaceholder}
                allowClear
                enterButton={
                  <Button type="primary" icon={<SearchOutlined />}>
                    搜索
                  </Button>
                }
                onSearch={onSearch}
                loading={loading}
              />
            </div>
          )}

          {filters.map((filter, index) => (
            <div key={filter.key || index} className="filter-bar-item">
              {filter.label && (
                <Text type="secondary" className="filter-bar-label">
                  {filter.label}
                </Text>
              )}
              {renderFilterElement(filter)}
            </div>
          ))}
        </div>

        {actions && (
          <div className="filter-bar-actions">
            {actions}
          </div>
        )}
      </div>
    </Card>
  );
};

const renderFilterElement = (filter) => {
  switch (filter.type) {
    case 'select':
      return (
        <Select
          placeholder={filter.placeholder || `选择${filter.label || ''}`}
          allowClear
          style={{ width: filter.width || 160 }}
          options={filter.options}
          value={filter.value}
          onChange={filter.onChange}
          mode={filter.mode}
          size={filter.size}
        />
      );

    case 'date':
      return (
        <DatePicker
          placeholder={filter.placeholder || `选择${filter.label || ''}`}
          style={{ width: filter.width || 160 }}
          value={filter.value}
          onChange={filter.onChange}
          format={filter.format}
          size={filter.size}
        />
      );

    case 'dateRange':
      return (
        <DatePicker.RangePicker
          placeholder={filter.placeholder || ['开始日期', '结束日期']}
          style={{ width: filter.width || 240 }}
          value={filter.value}
          onChange={filter.onChange}
          format={filter.format}
          size={filter.size}
        />
      );

    case 'custom':
      return filter.render?.();

    default:
      return null;
  }
};

export default memo(FilterBar);